import { Button } from "@mui/material"
import { toast } from "react-toastify"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { openGenericObjectModalAsync } from "../ModalGenericObject/useGenericObjectModalStore";
import { getEmpleados } from "@/shared/actions/erp/empleados";
import { fieldsUser } from "@/shared/utils/fields-modal-generic-object";

type InfoUserButtonProps = {
  user?: string | null
  emptyFallback?: string
}

export default function InfoUser({
  user,
}: InfoUserButtonProps) {

  if (!user) {
    return '—'
  };

  return (
    <Button
      variant="text"
      startIcon={<OpenInNewIcon />}
      onClick={async () => {
        try {

          if (!user) {
            toast.info('Sin asesor asignado')
            return;
          }

          openGenericObjectModalAsync({
            fetcher: async () => {
              const resp = await getEmpleados({
                username: user
              })
              return resp.data.data[0]
            },
            fields: fieldsUser,
            title: "Información",
            emptyFallback: "—",
          });

        } catch (error) {

          toast.error('Lo sentimos, no pudimos completar tu solicitud. [404]')
        }

      }}
    >{user}</Button>
  )

}